import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const loadCategories = createAsyncThunk(
  "categories/loadCategories",
  async (subreddits) => {
    //const response = await fetch("https://www.reddit.com/r/popular.json");
    const response = await fetch(`https://www.reddit.com/r/${subreddits}.json`);
    //const response = await fetch(`https://www.reddit.com/r/${subreddit}/${link}.json`); //fetching new posts from r/funny, r/programmerhumor, and r/software
    const json = await response.json();
    return json.data.children;
  }
);

export const loadSubreddit = createAsyncThunk(
  "categories/loadSubreddit",
  async (subreddits) => {
    const response = await fetch(`https://www.reddit.com/r/${subreddits}.json`);
    const json = await response.json();
    return json.data.children;
  }
);
export const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    category: [],
    status: "idle",
    isLoadingCategories: false,
    failedToLoadCategories: false,
    error: "",
    subreddit: {
      name: "AskReddit",
      subCategory: [],
      subredditError: false,
      subredditStatus: "idle",
    },
  },

  extraReducers: {
    [loadCategories.pending]: (state, action) => {
      state.isLoadingCategories = true;
      state.failedToLoadCategories = false;
      state.status = "loading";
    },
    [loadCategories.fulfilled]: (state, action) => {
      state.isLoadingCategories = false;
      state.failedToLoadCategories = false;
      state.status = "success";
      state.category = action.payload;
    },

    [loadCategories.rejected]: (state, action) => {
      state.isLoadingCategories = false;
      state.failedToLoadCategories = true;
      state.status = "failed";
      state.error = action.error.message;
    },

    [loadSubreddit.pending]: (state, action) => {
      state.subreddit.subredditError = false;
      state.subreddit.subredditStatus = "loading";
    },
    [loadSubreddit.fulfilled]: (state, action) => {
      state.subreddit.subredditError = false;
      state.subreddit.subredditStatus = "success";
      state.subreddit.subCategory = action.payload;
    },

    [loadSubreddit.rejected]: (state, action) => {
      state.subreddit.subredditError = true;
      state.subreddit.subredditStatus = "failed";
      state.subreddit.subredditError = action.error.message;
    },
  },
});

export const selectAllCategories = (state) => state.categories.category;

export const isLoading = (state) => state.categories.isLoadingCategories;

export const isFailed = (state) => state.categories.failedToLoadCategories;

export const selectSubreddit = (state) =>
  state.categories.subreddit.subCategory;

export default categoriesSlice.reducer;
